import InlineCommentButtonView from 'backbone/story/views/comments/inline_comment_button_view.js'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class InlineCommentTextView extends Backbone.View
  events:
    "click mark" : "onMarkClick"
    "mouseup"    : "onHighlight"
    "touchend"   : "onHighlight"

  initialize: (options) ->
    @options = options
    @inline = true
    @$storyContentWrapper = $("#js-view-story-container")
    @$commentPlaceholder = $(".js-comment-placeholder")
    @permittedToComment = window.story.permitted_to_comment || false

    @dispatcher = BackboneDispatcher.get_instance()
    @inlineCommentUtils = new InlineCommentUtils()
    @commentViewMediator = page.get("commentViewMediator")
    @commentViewMediator.registerView(this)
    @commentCollection = page.get("storyComments")
    @listenTo(@commentCollection, "change:resolved", @onResolvedChange)
    @listenTo(@commentCollection, "add", @_onInlineCommentCreated)
    @_showMarks()

  onHighlight: (e) =>
    if $(e.target).is("mark") && !@commentCollection.fetched
      @showCommentButton(false)
      return
    setTimeout( =>
      sel = window.getSelection()
      selHtml = @getSelectionHtml()
      if sel.toString().length > 2
        if @inlineCommentUtils.validateCommentSelection(selHtml, sel)
          e.stopPropagation()
          @showCommentButton()
        else
          @showCommentButton(false)
    , 10)

  removeCommentButton: ->
    @$commentButton.remove() if @$commentButton

  showCommentButton: (enabled = true) ->
    return unless @permittedToComment
    return if @commentViewMediator.commentInProgress()
    topOffset = @topOffset()

    @$commentButton.remove() if @$commentButton

    @$commentButton = new InlineCommentButtonView(
      top: topOffset,
      enabled: enabled
      fetched: @commentCollection.fetched
    ).render().$el

    @$commentPlaceholder.append @$commentButton

    if enabled
      @$commentButton.on "mouseup", @commentButtonClick

  topOffset: (offsetMarker) ->
    if offsetMarker
      if offsetMarker.length > 0
        markId = offsetMarker
      else
        markId = offsetMarker.get("mark_id")

    lineHeightOffset = if @$el.is(".headline-field") then 6 else 15
    placeholderWrapper = @$commentPlaceholder.offset().top

    if markId
      $mark = @markElementFromMarkId(markId)
      if $mark.length > 0
        selection = $mark.filter(":visible").offset()
        return selection.top - placeholderWrapper - lineHeightOffset
    else
      selection = window.getSelection().getRangeAt(0).getBoundingClientRect()
      return ($(window).scrollTop() + selection.top) - placeholderWrapper - lineHeightOffset

  commentButtonClick: (e) =>
    e.stopPropagation()
    @_deactivateMarks() unless @_thisCommentInProgress()

    sel = window.getSelection()
    markGroup = @inlineCommentUtils.insertProvisionalMarks(sel)
    
    # Basic check for required properties
    if !markGroup || !markGroup.markId || !markGroup.text()
      @removeCommentButton()
      return false
    
    # For v1 stories, ensure we have a text_model_id
    if @options.textModelType == "StoryText" && !@options.textModelId && window.story && window.story.story_text_id
      @options.textModelId = window.story.story_text_id
    
    @commentViewMediator.renderCommentForm
      view: this
      offset: @topOffset(markGroup.markId)
      markId: markGroup.markId
      highlightedText: markGroup.text()
      provisionalMarks: markGroup.marks
      inline: true
      text_model_type: @options.textModelType
      text_model_id: @options.textModelId
      text_model_attribute: @options.textModelAttribute

  onMarkClick: (e) ->
    return unless @commentCollection.fetched
    return if @commentViewMediator.commentInProgress()
    e.stopPropagation()
    $target = $(e.currentTarget)
    return if $target.hasClass("active") || $target.hasClass("disabled")
    return if $target.attr('data-provisional') == 1
    $target.addClass("active")
    markId = $target.attr("data-mark-id")
    @markElementFromMarkId(markId).addClass("active")
    comment = @commentCollection.find (comment) ->
      comment.get("mark_id") == markId
    @renderCommentView(comment, e)
    # Stop propagation halts other code listening to clicks
    # We use this because the scope of our views is too wide
    # This is not good, and should be addressed so we don't need this dispatch
    @dispatcher.trigger("deactivateContentAssist")

  activateMark: (comment) ->
    markId = comment.get("mark_id")
    @markElementFromMarkId(markId).addClass("active")

  renderCommentView: (comment) ->
    @commentViewMediator.showInlineComment
      view: this
      comment: comment
      offset: @topOffset(comment)

  markElementFromMarkId: (markId) ->
    # Scoping this to current view element is important, because rendering
    # the CommentView only renders the template if there is a markId -
    # so if this is globally scoped the CommentView will get rendered
    # as many times as this view has been instantiated on the page.
    @$el.find("mark[data-mark-id='#{markId}']")

  onCommentFormCanceled: =>
    unless @commentCollection.activeComment()
      @inlineCommentUtils.removeProvisionalMarks(@$el)
      @disableActiveMarks()
      @removeCommentButton()

  disableActiveMarks: =>
    @$el.find("mark.active").each ->
      $(this).removeClass("active")

  getSelectionHtml: ->
    html = ''
    if typeof window.getSelection != 'undefined'
      sel = window.getSelection()
      if sel.rangeCount
        container = document.createElement('div')
        i = 0
        len = sel.rangeCount
        while i < len
          container.appendChild sel.getRangeAt(i).cloneContents()
          ++i
        html = container.innerHTML
    else if typeof document.selection != 'undefined'
      if document.selection.type == 'Text'
        html = document.selection.createRange().htmlText
    html

  ### MEDIATOR CALLBACKS ###

  onViewOpen: (comment) ->
    @activateMark(comment)

  onViewClose: (comment) ->
    @_deactivateMarks(comment)

  onCommentFormClose: ->
    @onCommentFormCanceled()

  onResolvedChange: (comment) =>
    for mark in @inlineCommentUtils.markForId(comment.get("mark_id"))
      @inlineCommentUtils.removeMark($(mark))

  commentInView: (comment) ->
    @markElementFromMarkId(comment.get("mark_id")).length > 0

  openCommentView: (comment) ->
    @renderCommentView(comment)

  _deactivateMarks: ->
    @removeCommentButton()
    @inlineCommentUtils.removeProvisionalMarks(@$el)
    @disableActiveMarks()
    @removeExtraCommentPadding()

  removeExtraCommentPadding: ->
    $(".panel").css("padding-top", "")

  _thisCommentInProgress: ->
    return false unless @commentFormView
    @commentViewMediator.commentInProgress()

  _showMarks: ->
    if @commentCollection.fetched
      @inlineCommentUtils.showMarksAndBindBehavior()
    else
      @listenTo(@commentCollection, "reset", @inlineCommentUtils.showMarksAndBindBehavior)



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/inline_comment_text_view.js.coffee